import { createAsyncThunk } from "@reduxjs/toolkit";
import paymentsService from "../../../api/services/payments";

export const initiateRaiffeisenPayment = createAsyncThunk(
  "payments/initiateRaiffeisenPayment",
  async (orderData, { rejectWithValue }) => {
    try {
      return await paymentsService.initiateRaiffeisenPayment(orderData);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);